var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "m-grid__item m-footer" }, [
    _c(
      "div",
      {
        staticClass:
          "m-container m-container--fluid m-container--full-height m-page__container"
      },
      [
        _c(
          "div",
          {
            staticClass:
              "m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop"
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "m-stack__item m-stack__item--left m-stack__item--middle m-stack__item--last"
              },
              [
                _c("span", { staticClass: "m-footer__copyright" }, [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(new Date().getFullYear() + " © Superaccess") +
                      "\n\t\t\t\t\t\t"
                  ),
                  _c("a", { staticClass: "m-link", attrs: { href: "#" } })
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "m-stack__item m-stack__item--right m-stack__item--middle m-stack__item--first"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "m-dropdown m-dropdown--up m-dropdown--inline m-dropdown--smallest m-dropdown--arrow m-dropdown--align-right m-dropdown--align-push",
                    attrs: { "data-dropdown-toggle": "click" }
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass:
                          "m-portlet__nav-link m-dropdown__toggle btn btn-secondary m-btn m-btn--icon m-btn--pill",
                        attrs: { href: "#" }
                      },
                      [
                        _c("span", { staticClass: "m-nav__link-text" }, [
                          _c("img", {
                            staticClass:
                              "carousel-control-next-icon icon-flag-selector",
                            attrs: {
                              src:
                                "/media/img/flags/" + _vm.$i18n.locale + ".png"
                            }
                          }),
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm._f("titleize")(
                                  _vm._f("translate")(_vm.$i18n.locale)
                                )
                              ) +
                              "\n              "
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "m-dropdown__wrapper language-dropdown" },
                      [
                        _c("div", { staticClass: "m-dropdown__inner" }, [
                          _c("div", { staticClass: "m-dropdown__body" }, [
                            _c("div", { staticClass: "m-dropdown__content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "m-scrollable",
                                  attrs: {
                                    "data-scrollable": "true",
                                    "data-max-height": "110",
                                    "data-max-width": "150"
                                  }
                                },
                                [
                                  _c(
                                    "ul",
                                    { staticClass: "m-nav text-nowrap" },
                                    _vm._l(
                                      Object.keys(_vm.$i18n.messages),
                                      function(language, index) {
                                        return _c(
                                          "li",
                                          {
                                            key: index,
                                            staticClass: "m-nav__item"
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "m-nav__link cursor-pointer",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.setLanguage(
                                                      language
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "m-nav__link-text"
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass:
                                                        "carousel-control-next-icon icon-flag-selector",
                                                      attrs: {
                                                        src:
                                                          "/media/img/flags/" +
                                                          language +
                                                          ".png"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                              " +
                                                        _vm._s(
                                                          _vm._f("titleize")(
                                                            _vm._f("translate")(
                                                              language
                                                            )
                                                          )
                                                        ) +
                                                        "\n                            "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                ]
                              )
                            ])
                          ])
                        ])
                      ]
                    )
                  ]
                )
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba671b0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba671b0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/layout/Footer.vue
// module id = 789
// module chunks = 0 54 179